import { gotoSite } from '../Navigation/navigation.actions';
import {
  startLoading,
  stopLoading,
  unpublishStoryAppConfig,
} from '../StoryEdit/story-edit.actions';
import {
  storyPublishCallOptions,
  storyUnPublishCallOptions,
} from '../../services/story-publish.services';
import { showSnackbarWithMessage } from '../Snackbar/snackbar.saga';
import { callApi } from '../api';
import { call, fork, put, take, select } from 'redux-saga/effects';
import {
  publishErrors,
  publishStory,
  unpublishStory,
} from './story-publish.actions';
import { getStoryEditActiveAppId } from '../StoryEdit/story-edit.reducer';

export function* doPublish() {
  yield put(startLoading());

  const {
    storyEdit: { activeAppId, story, appConfigs },
  } = yield select();
  const publishCallOptions = storyPublishCallOptions(
    appConfigs[activeAppId] && appConfigs[activeAppId].id,
    story.id
  );

  try {
    const publishResponse = yield call(callApi, publishCallOptions);
    if (publishResponse.ok) {
      yield fork(showSnackbarWithMessage, 'success', 'Story published');

      if (publishResponse.data.errors && publishResponse.data.errors.warnings) {
        yield publishResponse.data.errors.warnings.map((warning: string) => {
          return fork(showSnackbarWithMessage, 'warning', warning);
        });
      }

      yield put(gotoSite('/stories'));
    } else {
      if (publishResponse && publishResponse.data && publishResponse.errors) {
        yield fork(
          showSnackbarWithMessage,
          'error',
          'Story could not be published'
        );

        yield put(
          publishErrors({
            errors: publishResponse.data.errors.errors,
            warnings: publishResponse.data.errors.warnings,
          })
        );
      }
    }
  } catch (error) {
    yield fork(showSnackbarWithMessage, 'error', error);
  }

  yield put(stopLoading());
}

export function* watchForPublishStory() {
  while (true) {
    yield take(publishStory.type);
    yield doPublish();
  }
}

export function* watchForUnpublishStory() {
  while (true) {
    const {
      payload: { appConfigId, storyId },
    } = yield take(unpublishStory.type);

    const publishCallOptions = storyUnPublishCallOptions(appConfigId, storyId);
    const { ok } = yield call(callApi, publishCallOptions);
    if (ok) {
      const state = yield select();
      const appId = getStoryEditActiveAppId(state);

      yield put(unpublishStoryAppConfig({ appId }));

      yield fork(showSnackbarWithMessage, 'success', 'Story was unpublished');
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/StoryPublish/story-publish.saga.ts